<template>
  <div class="login">
    <div class="login_area">
      <h1>
        <svg><use xlink:href="/svg/sprite.svg#logo" /></svg>
      </h1>
      <form action="" method="POST" class="login_form">
        <ul>
          <li class="login_id">
            <i class="material-icons"> account_circle </i
            ><input
              type="text"
              v-model="ID"
              placeholder="〇〇〇〇〇@ichibanya.jp"
              v-on:keyup.enter="submitLogin"
            />
          </li>
          <li class="login_pass">
            <i class="material-icons"> vpn_key </i
            ><input
              type="password"
              v-model="PASS"
              placeholder=""
              v-on:keyup.enter="submitLogin"
            />
          </li>
        </ul>
        <p class="btnbox">
          <button type="button" v-on:click="submitLogin" class="btn01 cl_bl">
            LOGIN
          </button>
        </p>
        <p class="error__text" v-if="error">認証できませんでした</p>
      </form>
    </div>
  </div>
</template>
<script>
import { Mixin } from "../mixin";
export default {
  name: "Login",
  mixins: [Mixin],
  data() {
    return {
      ID: "",
      PASS: "",
      error: "",
    };
  },
  created() {},
  methods: {
    submitLogin: function () {
      var self = this;
      let params = new URLSearchParams();
      params.append("c", "login");
      params.append("ID", self.ID);
      params.append("PASS", self.PASS);
      this.axios
        .post(this.RequestURI, params, {
          headers: {
            "Cache-Control": "no-cache",
          },
        })
        .then((res) => {
          if (res.data.status == "success") {
            //Cookie発行
            if (res.data.login.lo_pk) {
              this.$cookies.set("lo_pk", res.data.login.lo_pk);
              this.$cookies.set("lo_sid", res.data.login.lo_sid);
              this.$cookies.set("lo_name", res.data.login.lo_name);
              this.$cookies.set(
                "lo_opening_caution",
                res.data.login.lo_opening_caution
              );
              this.$router.push("/");
            }
          } else {
            self.error = 1;
          }
        })
        .catch((e) => {
          alert(e);
        });
    },
  },
};
</script>
